import actions from '@/store/modules/checkout/actions'
import Config from 'config'
import GQSetShippingMethodsOnCart from './graphql/setShippingMethodsOnCart'
import GQPlaceOrder from './graphql/placeOrder'
import GQSetPaymentMethodOnCart from './graphql/setPaymentMethodOnCart'
import GQGetCart from '@/store/modules/checkout/graphql/getCart'
import Graphql from '@/services/Graphql'
import { graphqlManageError } from '@/helpers'
// import PayByLink from 'theme/services/Adyen/PayByLink'
import HttpProvider from '@/services/HttpProvider'

function getCartID (ctx) {
  return ctx.rootState.cart.cartId
}

actions.init = async (ctx) => {
  // get cartid Mask or simple, depend if logged user
  let cartId = await ctx.dispatch('cart/getCartIDMask', {}, { root: true })
  if (cartId) {
    const token = ctx.rootState.user.token
    const storeViewCode = ctx.rootState.ui.storeViewCode
    const params = { cartId }
    const useCache = false
    const useInlineQuery = { query: GQGetCart }
    return Graphql.genericCall({}, token, storeViewCode, null, params, useCache, useInlineQuery)
      .then(res => {
        if (graphqlManageError(res)) {
          // eslint-disable-next-line
          throw { errors: [{ message: graphqlManageError(res) }] }
        }
        const cart = res.data.cart ? res.data.cart : null
        cart && ctx.commit('updCart', cart)
        return cart
      })
  } else {
    // eslint-disable-next-line
    throw { errors: [{ message: 'cart id required' }] }
  }
}

actions.cartDetails = (ctx, { email, cardCode, forceDestroy }) => {
  if (forceDestroy) {
    ctx.commit('cart/setLoyaltyThresholds', {}, { root: true })
    ctx.commit('cart/setLoyaltyReward', {}, { root: true })
    ctx.commit('cart/setLoyaltyCustomer', {}, { root: true })
    ctx.commit('cart/setGiftCards', [], { root: true })
    return true
  } else {
    let query = Config.API.cart.cartDetails
      .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    return HttpProvider.get(query, {
      params: {
        email,
        coinCode: cardCode
      }
    })
      .then((res) => {
        let details = res.data
        if (details) {
          let { customer, rewards, loyaltyThresholds, giftcards } = details
          ctx.commit('cart/setLoyaltyThresholds', loyaltyThresholds, { root: true })
          ctx.commit('cart/setLoyaltyReward', rewards, { root: true })
          ctx.commit('cart/setLoyaltyCustomer', customer, { root: true })
          ctx.commit('cart/setGiftCards', giftcards, { root: true })
          return details
        } else {
          return new Error('generic-error')
        }
      })
      .catch(error => {
        throw error
      })
  }
}

actions.setGiftCard = (ctx, { cardCode, cardAmount, paymentInstrumentId, add }) => {
  const cartId = getCartID(ctx)
  const amount = cardAmount <= ctx.rootGetters['cart/totalAmount'] ? cardAmount : ctx.rootGetters['cart/totalAmount']
  const paymentMethodId = 'GIFT_CERTIFICATE'
  const paymentMethodType = 'GiftCertificate'
  const query = Config.API.cart.setGiftCard
    .replace('{{cartId}}', cartId)
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
  if (cardCode) {
    return HttpProvider.post(query, {
      gift_certificate_code: cardCode,
      amount,
      payment_instrument_id: paymentInstrumentId,
      payment_method_id: paymentMethodId,
      payment_method_type: paymentMethodType,
      add
    })
      .then((res) => {
        const cart = res.data ? res.data.cart : null
        const gifts = res.data ? res.data.giftcards : []
        cart && ctx.commit('updCart', cart)
        gifts && ctx.commit('cart/setActiveGiftCards', gifts, { root: true })
        return res
      })
  } else {
    return Promise.reject(new Error({ message: 'No codes found' }))
  }
}

actions.setShippingMethods = async (ctx, shippingMethod) => {
  const cartId = getCartID(ctx)
  const shippingMethods = [{
    carrier_code: shippingMethod.carrier_code,
    method_code: shippingMethod.method_code
  }]
  // delete shippingMethod.carrier_code
  // delete shippingMethod.method_code
  if (cartId) {
    return Graphql.genericCall(
      {},
      ctx.rootState.user.token,
      ctx.rootState.ui.storeViewCode,
      null,
      {
        input: {
          cart_id: cartId,
          shipping_methods: shippingMethods,
          ...shippingMethod
        }
      }, // variable
      false, // cache
      {
        query: GQSetShippingMethodsOnCart
      }
    ).then(res => {
      if (graphqlManageError(res)) {
        // eslint-disable-next-line
        throw { errors: [{ message: graphqlManageError(res) }] }
      }
      // const cart = res.data.setShippingMethodsOnCart ? res.data.setShippingMethodsOnCart.cart : null
      const cart = res.data.viewideSetShippingMethodOnCart ? res.data.viewideSetShippingMethodOnCart.cart : null
      cart && ctx.commit('updCart', cart)
      ctx.commit('setShippingMethod', shippingMethod.carrier_code || '')
      return cart
    })
  } else {
    // eslint-disable-next-line
    throw { errors: [{ message: 'cart id required' }] }
  }
}

actions.setInvoice = async (ctx, { invoice = {} }) => {
  const cartId = getCartID(ctx)
  const query = Config.API.cart.setInvoice
    .replace('{{cartId}}', cartId)
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)

  return HttpProvider.post(query, { invoice })
    .then((res) => {
      const cart = res.data.data.cart ? res.data.data.cart : null
      cart && ctx.commit('updCart', cart)
      return cart
    })
}

actions.setPaymentMethod = (ctx, paymentMethod) => {
  const cartId = getCartID(ctx)
  return Graphql.genericCall(
    {},
    ctx.rootState.user.token,
    ctx.rootState.ui.storeViewCode,
    null,
    {
      input: {
        cart_id: cartId,
        payment_method: {
          code: paymentMethod.code,
          type: paymentMethod.type,
          additional_data: paymentMethod.additionalData
        }
      }
    }, // variable
    false, // cache
    {
      query: GQSetPaymentMethodOnCart
    }
  )
    .then(res => {
      if (graphqlManageError(res)) {
        // eslint-disable-next-line
        throw { errors: [{ message: graphqlManageError(res) }] }
      } else {
        return res
      }
    })
    .catch((err) => {
      return err
    })
}

actions.placeOrder = (ctx) => {
  const cartId = getCartID(ctx)

  return Graphql.genericCall(
    {},
    ctx.rootState.user.token,
    ctx.rootState.ui.storeViewCode,
    null,
    {
      input: {
        cart_id: cartId
      }
    },
    false, // cache
    {
      query: GQPlaceOrder
    }
  )
    .then(res => {
      const order = res.data.viewidePlaceOrder.order
      if (!order) {
        // eslint-disable-next-line
        throw { body: { result: 'order not valid' } }
      }
      ctx.commit('orders/setOrder', order, { root: true })
      return order
    })
}

actions.empty = (ctx) => {
  // reset shipping and billing address
  ctx.commit('setEmail', '')
  ctx.commit('setShippingAddress', null)
  ctx.commit('setShippingAddress', null)
  ctx.commit('setBillingAddress', null)
  ctx.commit('setPaymentSelected', '')
  ctx.commit('setShippingMethod', null)
  ctx.commit('setShipToStore', false)
  ctx.commit('setShipStoreId', '')
}

actions.managePriceAdjustments = (ctx, payload) => {
  const cartId = getCartID(ctx)
  let query = Config.API.cart.managePriceAdjustments
    .replace('{{cartId}}', cartId)
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
  return HttpProvider.post(query, { ...payload })
}

export default {
  ...actions
}
